import { createFileRoute, Outlet } from "@tanstack/react-router";

import { Footer } from "@/components";

const BaseLayout = () => {
  return (
    <div className="flex flex-1 flex-col">
      <main className="flex flex-1 flex-col bg-canvas">
        <Outlet />
      </main>

      <Footer />
    </div>
  );
};

export const Route = createFileRoute("/_private/(with-footer)")({ component: BaseLayout });
